<template>
  <v-list-group dense prepend-icon="poll" active-class="activeLinkGroup" no-action>
    <v-list-tile slot="activator">
      <v-list-tile-title>{{ $t("App.Reports") }}</v-list-tile-title>
    </v-list-tile>
    <v-divider />
    <v-list dense class="py-0">
      <!-- <v-list-tile v-if="isSystemAdmin" ripple active-class="activeLink">
        <v-list-tile-title>Scheduled Reports</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>schedule</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
      <v-list-tile v-if="isSystemAdmin" ripple active-class="activeLink">
        <v-list-tile-title>Reports Archive</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>inventory</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
      <v-list-tile v-if="isSystemAdmin" ripple :to="{ name: 'rFrameworkViewer' }" active-class="activeLink">
        <v-list-tile-title>View Report (for testing)</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>analytics</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
      <v-subheader class="mt-2">Available reports:</v-subheader>
      <v-list-tile v-if="isSystemAdmin" ripple :to="{ name: 'sampleFrameworkReport' }" active-class="activeLink">
        <v-list-tile-title>Sample Framework</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>analytics</v-icon>
        </v-list-tile-avatar>
      </v-list-tile> -->
      <v-list-tile v-if="reportTypeIsVisible(reportObjects.wqMonthly.configKey) || reportTypeIsVisible(reportObjects.bcMoeMonthly.configKey)" ripple :to="{ name: 'monthlyWaterQualityReport' }" active-class="activeLink">
        <v-list-tile-title>Monthly Water Quality</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>analytics</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
      <v-list-tile v-if="reportTypeIsVisible(reportObjects.riss.configKey)" ripple :to="{ name: 'monthlyRISSReport' }" active-class="activeLink">
        <v-list-tile-title>Monthly RISS</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>analytics</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
      <v-list-tile v-if="reportTypeIsVisible(reportObjects.allExport.configKey)" ripple :to="{ name: 'exportAllDataReport' }" active-class="activeLink">
        <v-list-tile-title>Export All Data</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>analytics</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
      <v-list-tile :to="{ name: 'discreteDataQueryReport' }" ripple active-class="activeLink">
        <v-list-tile-title>{{ $t("App.DiscreteDataQuery") }}</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>analytics</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>

      <v-list-tile :to="{ name: 'continuousDataQueryReport' }" ripple active-class="activeLink">
        <v-list-tile-title>{{ $t("App.ContinuousDataQuery") }}</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>mdi-chart-areaspline</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>

      <v-list-tile :to="{ name: 'rpdReport' }" ripple active-class="activeLink">
        <v-list-tile-title>{{ $t("App.RpdReport") }}</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>compare_arrows</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>

      <v-list-tile v-if="reportTypeIsVisible(reportObjects.bcMOE.configKey)" ripple :to="{ name: 'BCMOEReport' }" active-class="activeLink">
        <v-list-tile-title>{{ currentUserGroup.id == 202  ? 'NWB Monthly Report' : 'BC MOE Report' }}</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>mdi-chart-areaspline-variant</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>

      <v-list-tile v-if="reportTypeIsVisible(reportObjects.tenantGraphDashboard.configKey)" ripple :to="{ name: 'tenantGraphDashboard' }" active-class="activeLink">
        <v-list-tile-title>Graphing Dashboard</v-list-tile-title>
        <v-list-tile-avatar>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-tile-avatar>
      </v-list-tile>
    </v-list>
  </v-list-group>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import {
    reportTypes,
  } from '@/store/stations'
  import {
    UiConfigKeys,
  } from '@/store/UI/uiconfig'

  const uiConfig = createNamespacedHelpers('uiconfig')
  const authenticate = createNamespacedHelpers('authenticate')

  export default {
    computed: {
      ...uiConfig.mapGetters(['uiConfigOptions', 'uiConfigOptionByKey']),
      ...authenticate.mapGetters(['isSystemAdmin', 'currentUserGroup']),
      reportVisibilityOption() {
        let data = this.uiConfigOptionByKey(
          UiConfigKeys.ReportComponentVisibility
        )
        if (!(data && data.Value)) {
          return []
        }
        return JSON.parse(data.Value)
      },
      reportObjects() {
        return reportTypes
      },
    },
    methods: {
      ...uiConfig.mapActions(['getUiConfigOptions']),
      reportTypeIsVisible(reportTypeConfigKey) {
        return this.reportVisibilityOption.includes(reportTypeConfigKey)
      },
    },
  }
</script>